export default "__VITE_ASSET__MIez5vmY__"